/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import apiClient from '../../../services/api-client';
import { RootState } from '../../../store/rootReducer';
import { SeedStoreInfo, SeedStoresState } from '../types/SeedOrderFormType';

export const getSeedStores = createAsyncThunk<SeedStoreInfo[], void>(
  'seedStores/getSeedStores',
  async () => {
    const request = await apiClient.get<SeedStoresState, AxiosError>(`/seed-stores`);
    return request.data.stores;
  },
);

export const initialState: SeedStoresState = {
  stores: [],
};

const SeedStoresSlice = createSlice({
  name: 'seedStores',
  initialState: initialState,
  extraReducers: (builder) => {
    builder.addCase(getSeedStores.fulfilled, (state, { payload }) => {
      state.stores = [...payload].sort((a, b) => a.name.localeCompare(b.name));
    });
  },
  reducers: {},
});

const selectState = (state: RootState) => state.seedStores;

export const selectStores = createSelector(selectState, (state) => state.stores);

export const selectSeedStoreById = (id: string | undefined) => {
  return createSelector(selectState, (state) => {
    const store = state.stores.find((i) => i.id === id);
    return store;
  });
};

export default SeedStoresSlice;
